// extracted by mini-css-extract-plugin
export var section = "sectionTableOfContents-module--section--ad915";
export var showTitleAboveList = "sectionTableOfContents-module--showTitleAboveList--d84cd";
export var table = "sectionTableOfContents-module--table--46c2d";
export var title = "sectionTableOfContents-module--title--7ed0c";